module.exports = __webpack_public_path__ + "static/media/close.6a0ab8e3.svg";